'use client'

import React from 'react';
import './next-match-card.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faClock, faTrophy } from '@fortawesome/free-solid-svg-icons';
import { stageMeta } from './stage';

const NextMatchCard = ({ match, logoClass }) => {
  if (!match) return null;

  const { date, time, matchnumber, venue, city, team1_flag, team2_flag, stage } = match;
  const meta = stageMeta(stage);
  const themeClass = meta ? `next-match--playoff next-match--${meta.key}` : '';
  const labelText = meta ? meta.label : 'Upcoming';

  return (
    <div className={`next-match ${themeClass} animate__animated animate__fadeIn`}>
      {/* Large match number watermark behind content */}
      <span className="next-match__watermark" aria-hidden="true">
        {matchnumber}
      </span>

      <div className="next-match__label">
        <span className="next-match__label-text">
          {meta?.key === 'final' && <FontAwesomeIcon icon={faTrophy} className="next-match__label-icon" />}
          {labelText}
        </span>
      </div>

      <div className="next-match__body">
        <div className="next-match__team">
          <span className={`${logoClass} ${team1_flag} next-match__flag`} />
          <span className="next-match__code">{team1_flag?.toUpperCase()}</span>
        </div>

        <div className="next-match__vs">VS</div>

        <div className="next-match__team">
          <span className={`${logoClass} ${team2_flag} next-match__flag`} />
          <span className="next-match__code">{team2_flag?.toUpperCase()}</span>
        </div>
      </div>

      <div className="next-match__separator" />
      <div className="next-match__meta">
        <span className="next-match__meta-item">
          <FontAwesomeIcon icon={faClock} />
          {time}, {moment(date).format('ddd, DD MMM YYYY')}
        </span>
        <span className="next-match__meta-item">
          <FontAwesomeIcon icon={faMapMarkerAlt} />
          {venue}{city ? `, ${city}` : ''}
        </span>
      </div>
    </div>
  );
};

export default NextMatchCard;
